import * as React from 'react';
import { OverlayTrigger } from 'react-bootstrap';

interface ITooltipProps {
  tooltipText: string;
  trigger?: any;
  position?: 'top' | 'bottom' | 'right' | 'left';
}

export default class Tooltip extends React.Component<ITooltipProps, {}> {
  public static defaultProps: ITooltipProps = {
    trigger: ['focus', 'hover'],
    position: 'top',
    tooltipText: 'Replace Text',
  };

  render() {
    const { tooltipText, position, trigger } = this.props;

    const tooltip = (props) => (
      <Tooltip id="tooltip" {...props}>
        <strong>{tooltipText}</strong>
      </Tooltip>
    );

    return tooltipText ? (
      <OverlayTrigger overlay={tooltip} trigger={trigger} placement={position}>
        {this.props.children as any}
      </OverlayTrigger>
    ) : (
      this.props.children
    );
  }
}
